import PropTypes from 'prop-types';
import React from 'react';
import cx from 'classnames';
import qs from 'query-string';
import { Link } from 'react-router-dom';
import styles from './Pagination.module.scss';
import { searchToQuery } from 'utils/config';

const Pagination = ({
  total = 1,
  current = 1,
  location,
}) => {
  if (total === 1) {
    return null;
  }
  const delta = 2;
  const left = current - delta;
  const right = current + delta;
  const range = [...Array(delta * 2 + 1).keys()].reduce((acc, counter) => {
    const cur = current - delta + counter;
    if (cur >= 1 && cur <= total) acc.push(cur);
    return acc;
  }, []);
  const getPage = num => (
    <li
      key={num}
      className={num === current ? cx(styles.active, 'active') : ''}
    >
      {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
      <Link
        to={`${location.pathname}?${qs.stringify({
          ...searchToQuery(location.search),
          page: num,
        })}`}
      >
        {num}
      </Link>
    </li>
  );
  const ellipsis = (
    <li>
      <span>&hellip;</span>
    </li>
  );
  return (
    <div className="cs-pagination">
      <ul className={cx(styles.pagination, 'pagination')}>
        <li>
          {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
          {(current > 1 && (
            <Link
              to={`${location.pathname}?${qs.stringify({
                ...location.query,
                page: current - 1,
              })}`}
            >
              &lt;
            </Link>
          )) || <span>&lt;</span>}
        </li>
        {1 < left && getPage(1)}
        {2 < left && ellipsis}
        {range.map(num => getPage(num))}
        {total > right + 1 && ellipsis}
        {total > right && getPage(total)}
        <li>
          {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
          {(current < total && (
            <Link
              to={`${location.pathname}?${qs.stringify({
                ...searchToQuery(location.search),
                page: current + 1,
              })}`}
            >
              &gt;
            </Link>
          )) || <span>&gt;</span>}
        </li>
      </ul>
    </div>
  );
};

Pagination.propTypes = {
  total: PropTypes.number.isRequired,
  current: PropTypes.number.isRequired,
  location: PropTypes.object.isRequired,
};

export default Pagination;
